// Use get hook
// Params
// response: The response value
// url: The url we want to fetch from
import { useState, useEffect } from 'react';
import axios from 'axios';

const { CancelToken } = axios;
let cancel;

const useGet = (url, watch = []) => {
	const [response, setResponse] = useState(null);
	const [loading, setIsLoading] = useState(true);
	const [error, setIsError] = useState(false);

	useEffect(() => {
		axios.get(url, {
			cancelToken: new CancelToken(c => cancel = c)
		})
			.then((res) => {
				setIsLoading(false);
				setResponse(res);
			})
			.catch(() => {
				setIsLoading(false);
				setIsError(true);
			});

		return () => {
			cancel();
		};
	}, watch);

	return { response, loading, error };
};

export default useGet;
